// extracted by mini-css-extract-plugin
export default {"cls1":"UJ4vTbAu98oNA7PegsFZ","cls2":"VqpasFpRdbY3zHZy1Jdf UJ4vTbAu98oNA7PegsFZ"};